import { render, staticRenderFns } from "./DiagramDirectorsList.vue?vue&type=template&id=9c538e36&scoped=true&"
import script from "./DiagramDirectorsList.vue?vue&type=script&lang=js&"
export * from "./DiagramDirectorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c538e36",
  null
  
)

export default component.exports